import { MessageBox } from "element-ui"
import i18n from '@/utils/lang/index.js';
import router from '@/router'
export default {
	windowOpen(url) {
		let access_token = '';
		if (sessionStorage.getItem('token')) {
			access_token = JSON.parse(sessionStorage.getItem('token')).access_token
		}
		window.open(url, '_blank', {
			headers: {
				authorization: 'Bearer ' + access_token
			}
		})
	},
	tokenIsExpire(code) {
		if (code == 'Unauthenticated.') {
			sessionStorage.removeItem('token')
			sessionStorage.removeItem('userInfo')
			return true
		} else {
			return false
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/comJs/comJSIndex.JS
// module id = null
// module chunks = 